<template class="container">
  <div>
    <!-- @submit handles any form of submission.
    .prevent keeps the event from bubbling around 
    and doing anything else. -->
    <form
      class="search"
      @submit.prevent="getProfileSummary(profile)"
    >
      <div class="search-bar">
        <div class="control has-icons-left">
          <input
            v-model="profile"
            class="input"
            type="text"
            placeholder="Steam Profile"
            @click="errorMessage = ''"
          >
          <span class="icon is-small is-left">
            <i class="fas fa-search" />
          </span>
        </div>
        <p
          v-if="errorMessage"
          class="help is-danger"
        >
          {{ errorMessage }}
        </p>
      </div>
      <button
        type="submit"
        class="button is-dark search-button"
        :class="{ 'is-loading': showSpinner }"
        :disabled="!profile"
      >
        Find
      </button>
      <button
        class="button is-dark search-button has-tooltip-bottom"
        data-tooltip="Click here to return a sample profile."
        @click="tryMe()"
      >
        Try Me
      </button>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Search",
  props: {},
  data: function() {
    return {
      profile: "",
      showSpinner: false,
      profileDetails: {},
      errorMessage: "",
      apiURL: process.env.VUE_APP_API_URL
    };
  },
  watch: {
    // clear error message once input field edited and error message showing
    profile() {
      if (this.errorMessage) {
        this.errorMessage = "";
      }
    }
  },
  methods: {
    getProfileSummary: function() {
      this.showSpinner = true;
      axios
        .get(`${this.apiURL}/profile/${this.profile}`)
        .then(response => {
          this.errorMessage = "";
          this.showSpinner = false;
          this.profileDetails = response.data;
          this.$emit("addProfile", this.profileDetails);
          this.$emit("getFriends", this.profileDetails.steamid);
          this.clearProfileDetails();
        })
        .catch(err => {
          this.showSpinner = false;
          this.errorMessage = err.response.data.error;
        });
    },

    clearProfileDetails: function() {
      this.profileDetails = {};
    },

    tryMe: function() {
      this.showSpinner = true;
      axios
        .get(`${this.apiURL}/sample`)
        .then(response => {
          this.errorMessage = "";
          this.showSpinner = false;
          this.profileDetails = response.data;
          this.$emit("addProfile", this.profileDetails);
          this.$emit("getFriends", this.profileDetails.steamid);
          this.clearProfileDetails();
        })
        .catch(err => {
          this.showSpinner = false;
          this.errorMessage = err.response.data.error;
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "~bulma-tooltip";
.search-bar {
  width: 50%;
  max-width: 600px;
  margin: 0 auto 1em;
}
.search-button {
  margin: 0 0.5em;
}
.search {
  text-align: center;
}

@media only screen and (max-width: 640px) {
  .search-bar {
    width: 75%;
    margin: 0 auto 1em;
  }
}
</style>